import type { FC } from 'react';
import IconMdi from '@components/IconMdi';
import { Button } from '@components/ui/button';
import { mdiUnfoldLessHorizontal, mdiUnfoldMoreHorizontal } from '@mdi/js';

import { sidebarFooterClasses, sidebarListControlClasses } from './classes';

interface SidebarFooterProps {
  onExpandAll: () => void;
  onCollapseAll: () => void;
  expandLabel?: string;
  collapseLabel?: string;
  highlightedOption?: 'expand' | 'collapse' | 'none';
  className?: string;
}

export const SidebarFooter: FC<SidebarFooterProps> = ({
  onExpandAll,
  onCollapseAll,
  expandLabel = 'Expand all',
  collapseLabel = 'Collapse all',
  highlightedOption = 'none',
  className,
}) => {
  return (
    <div className={sidebarFooterClasses({ className })}>
      <Button variant="outline" size="sm" className="flex items-center gap-2 bg-white!" onClick={onExpandAll}>
        <IconMdi
          path={mdiUnfoldMoreHorizontal}
          className={sidebarListControlClasses({ isHighlighted: highlightedOption === 'expand' })}
        />
        <span>{expandLabel}</span>
      </Button>
      <Button variant="outline" size="sm" className="flex items-center gap-2 bg-white!" onClick={onCollapseAll}>
        <IconMdi
          path={mdiUnfoldLessHorizontal}
          className={sidebarListControlClasses({ isHighlighted: highlightedOption === 'collapse' })}
        />
        <span>{collapseLabel}</span>
      </Button>
    </div>
  );
};
